import { analytics, EEVENT_LABEL } from 'affiny-core/analytics';
import { Box, Flex, Icon, IconName, Pin, rem } from 'affiny-ui/src';
import React, { memo, useCallback } from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

interface IHeaderNavListItem {
  icon: IconName;
  label: string;
  url: string;
  disabled: boolean;
  activeOnlyWhenExact: boolean;
  showPin?: boolean;
  eventLabel: EEVENT_LABEL;
}

export const HeaderNavListItem = memo(
  ({
    icon,
    label,
    url,
    disabled,
    activeOnlyWhenExact,
    showPin = false,
    eventLabel,
  }: IHeaderNavListItem) => {
    const location = useLocation();

    const match =
      !!useRouteMatch({
        path: url,
        exact: activeOnlyWhenExact,
      }) ||
      (location.pathname === '/' && url === '/home');

    const handleItemClick = useCallback(() => {
      analytics.trackEvent(eventLabel);
    }, [eventLabel]);

    return (
      <SLink
        to={url}
        selected={match}
        disabled={disabled}
        onClick={handleItemClick}
      >
        <Flex alignItems="center" mr="small">
          <Icon name={icon} size={rem(24)} />
          {showPin && <Pin top={rem(-3)} right={rem(-3)} />}
        </Flex>
        {label}
        {match && (
          <Box
            width={`calc(100% - ${rem(8)})`}
            marginX={rem(4)}
            height={rem(4)}
            bg="accent"
            position="absolute"
            bottom={0}
            left={0}
          />
        )}
      </SLink>
    );
  }
);

const SLink = styled(Link)<{ selected: boolean; disabled: boolean }>`
  position: relative;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  height: 100%;
  min-height: ${rem(82)};
  font-size: ${({ theme }) => theme.fontSizes.size16};
  font-weight: 600;
  padding-left: ${rem(12)};
  padding-right: ${rem(12)};
  color: ${({ theme, selected }) =>
    selected ? theme.colors.accent : theme.colors.secondary};
  transition: color 300ms ease;
  box-sizing: border-box;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
`;
